<template>
    <v-layout column text-xs-center _signup-parent-3>
        <v-flex class="_signup-parent-3--header">
            <h1>Create your Free Account</h1>
            <p class="_signup-parent-3--intro">
                Browse NannyGrannies in your area and see who's available.<br/>
                Your Free Account is browse-only. Upgrade anytime when you're ready to connect.
            </p>
            <app-svg-icon name="brand/NG_DIVIDER"
                          color="var(--green)"
                          :width="$vuetify.breakpoint.xsOnly ? '100' : '139'"></app-svg-icon>
        </v-flex>
        <!--ACCOUNT FORM-->
        <v-flex>
            <v-container grid-list-lg w--max--800>
                <v-layout row wrap>
                    <v-flex xs12 sm6>
                        <v-text-field label="First name*"
                                      v-model="user.first_name"
                                      v-validate="'required'"
                                      :error-messages="errors.first('first_name')"
                                      data-vv-name="first_name"
                                      ref="first_name"
                                      outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field label="Last name*"
                                      v-model="user.last_name"
                                      v-validate="'required'"
                                      :error-messages="errors.first('last_name')"
                                      data-vv-name="last_name"
                                      ref="last_name"
                                      outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field label="Mobile phone*"
                                      v-model="user.phone"
                                      v-validate="'required'"
                                      :error-messages="errors.first('phone')"
                                      data-vv-name="phone"
                                      placeholder="0123456789"
                                      ref="phone"
                                      :mask="maskPhone"
                                      outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6> 
                        <app-input-postcode label="Postcode*"
                                            v-model="postcode"
                                            v-validate="'required'"
                                            data-vv-name="postcode"
                                            :hide-details="false"
                                            ref="postcode"
                                            :error-messages="errors.first('postcode')"
                                            outline></app-input-postcode>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-text-field label="Email*"
                                      v-model="user.email"
                                      :disabled="editingEmail"
                                      v-validate="'required|email'"
                                      :error-messages="errors.first('email')"
                                      ref="email"
                                      data-vv-name="email"
                                      outline></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-select 
                        label="How did you hear about us?" 
                        v-model="user.heard_from" 
                        :items="heardFromOptions"
                        item-value="id"
                        item-text="name"
                        :error-messages="errors.first('heard_from')"
                        v-validate="'required'"
                        data-vv-name="heard_from"
                        :menu-props="{ offsetY: true }"
                        outline>
                      </v-select>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
        <!--PAYMENT-->
        
        <v-flex class="text-xs-center px-3 pb-3">
            <v-btn @click="submit"
                   :loading="loading"
                   class="primary v-btn--default elevation-0 mt-2">
                Create Free Account
            </v-btn>
            <div class="v-text-field__details" v-if="isError()"><div class="v-messages theme--light error--text"><div class="v-messages__wrapper"><div class="v-messages__message">Missing information.</div></div></div></div>

        </v-flex>
        <!--BACKGROUND ELEMENTS-->
        <v-flex v-if="$vuetify.breakpoint.mdAndUp"
                class="_signup-parent-3--bg-elements">
            <app-svg-icon name="patterns/NG_Pattern-16"
                          color="none var(--orange)"
                          class="svg-icon--pattern-16"></app-svg-icon>
            <app-svg-icon name="brand/NG_JOIN_NETWORK"
                          color="var(--yellow)"
                          class="svg-icon--network"></app-svg-icon>
            <app-svg-icon name="brand/NG_ACTIVE"
                          color="var(--green)"
                          class="svg-icon--active"></app-svg-icon>
            <app-svg-icon name="brand/NG_CREATIVE_PLAY"
                          color="var(--orange)"
                          class="svg-icon--play"></app-svg-icon>
        </v-flex>
    </v-layout>
</template>

<script>
  import AppCardOrderSubscription from '@/components/app-card/app-card-order-subscription'
  import AppFormPaymentCreditCard from '../../../../../components/app-form/app-form-payment-credit-card'
  import { MW_MERCHANT_UUID, MW_API_KEY, MW_TEST_MODE } from '../../../../../config/constants'

  export default {
    name: 'auth-signup-step-2-parent',
    components: {AppFormPaymentCreditCard, AppCardOrderSubscription},
    data () {
      return {
        loading: false,
        editingEmail: false,
        maskPhone: '##########',
        user: {
          first_name: null,
          last_name: null,
          phone: null,
          email: null,
          postcode_id: null,
          heard_from: null
        },
        postcode: null,
        dictionary: {
          attributes: {
            first_name: 'first name',
            last_name: 'last name',
            phone: 'mobile phone'
          }
        },
        mwPayframe: null
      }
    },

    watch: {
      postcode () {
        this.user.postcode_id = this.$lodash.get(this.postcode, 'id', null)
      }
    },

    computed: {
      invoice () {
        return this.$store.getters['subscription/payments/invoice']
      },
      plan () {
        return this.$store.getters['subscription/selectedPlan']
      },
      heardFromOptions() {
        return this.$store.getters['heardFrom/list'];
      }
    },

    mounted () {
      this.$validator.localize('en', this.dictionary)
      this.$store.dispatch('heardFrom/HEARDFROM_GET')
        .catch(err => console.error('Error fetching heardFrom:', err));
    },

    created () {
      this.user.email = this.$auth.user().email
      this.user.new_free_user = 1
    },

    methods: {
      isError () {
        return this.errors.items.length > 0
      },
      scrollToFirstError() {
    // Find the first error field and scroll to it
    const errorFields = this.errors.items;
    if (errorFields.length > 0) {
      const firstErrorField = errorFields[0].field;
      const firstErrorElement = this.$refs[firstErrorField];
      if (firstErrorElement && firstErrorElement.$el) {
        firstErrorElement.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorElement.focus();
      }
    }
  },
      submit () {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.loading = true
            this.$store.dispatch('register/STEP_3', {data: this.user})
              .then(() => {
                // Purchase and finish register
              //  mwPayframe.submitPayframe(this)
              this.showSnackBar('Your profile has been set up successfully.', 'success')
              setTimeout(() => {
              this.$auth.fetch({
                enabled: true,
                success: () => {
                  this.$cookie.set('rememberMe', 'false')
                  window.location = '/dashboard'
                },
                error: () => (this.$router.push('login'))
              })
              }, 4000)
              })
              .catch(error => {
                
                this.loading = false
              });
          }
          else{
            this.scrollToFirstError();
          }
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .container
      z-index auto
    ._signup-parent-3
        position relative
        padding-bottom 40px
        &--intro
            font-size 16px
            margin 12px auto 0
            max-width 640px
        &--header .svg-icon
            margin 12px 0 0
        &--bg-elements
            .svg-icon
                position absolute
                &--pattern-16
                    width 110px
                    height 110px
                    top 80px
                    right 8%
                    transform rotate(40deg)
                &--network
                    width 90px
                    height 80px
                    top 35%
                    left 0
                    transform rotate(15deg)
                    @media (min-width 1200px)
                        left 5%
                        width 117px
                &--active
                    width 80px
                    height 116px
                    top 55%
                    right 0
                    @media (min-width 1200px)
                        right 5%
                &--play
                    width 80px
                    height 116px
                    top 85%
                    left 5%
</style>



// WEBPACK FOOTER //
// src/views/app/auth/signup/components/auth-signup-step-3-parentalternate.vue